import React, { ElementType } from 'react';

import { Flex, rem } from '@vimeo/bokeh';
import { InfoCircle } from '@vimeo/bokeh-icons';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';

import { createDomName } from '../../utils/dom/identifying';
import { BokehTooltip } from '../bokeh';

interface ICircleTipProps extends IBaseDomElementProps {
  label?: string;
  color?: string;
  placement?: string;
  width?: string | number;
  iconBoxSize?: string | number;
  as?: ElementType;
}

export function CircleTip({
  id = createDomName('circle-tip'),
  className = createDomName('circle-tip'),
  placement,
  color = 'text-secondary',
  width = rem(300),
  label,
  iconBoxSize = 16,
  as,
}: ICircleTipProps) {
  return label ? (
    <BokehTooltip label={label} placement={placement} width={width} maxWidth={width}>
      <Flex as={as} id={id} className={className} position={'relative'} cursor={'pointer'}>
        <InfoCircle boxSize={iconBoxSize} color={color} />
      </Flex>
    </BokehTooltip>
  ) : null;
}
